import {getCurEnvKey, removeCookie} from '@threegene/common-js/xdm/auth/token.ctrl';
import {handleAPI} from '@js/fetch';

/**
 * @desc 获取当前运行环境对应的枚举
 */
const tokenKey = getCurEnvKey();
let getUserInfoP;
const global = {
  namespaced: true,
  state: () => {
    return {
      tokenOfEnv: {},
      userInfo: {}
    };
  },
  getters: {
    token: state => {
      return state.tokenOfEnv[tokenKey];
    },
    userInfo: state => state.userInfo,
    userId: state => state.userInfo.id
  },
  mutations: {
    SET_TOKEN_ENV(state, tokenOfEnv) {
      state.tokenOfEnv = tokenOfEnv;
    },
    SET_TOKEN(state, token) {
      if (state.tokenOfEnv[tokenKey] === token) return;
      state.tokenOfEnv = {...state.tokenOfEnv, [tokenKey]: token};
    },
    REMOVE_TOKEN(state) {
      removeCookie('token');
      state.tokenOfEnv = {};
    },
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    }
  },
  actions: {
    async getUserInfo({commit}) {
      if (!getUserInfoP) getUserInfoP = handleAPI('GET_USER_INFO', null, {needToken: true});
      const data = await getUserInfoP;
      getUserInfoP = undefined;
      commit('SET_USERINFO', data);
    }
  }
};

export default global;



// WEBPACK FOOTER //
// ./src/store/modules/global.js